import styled from 'styled-components'
import { Colors } from 'styles/app-styles'

export const FolderPath_s = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 300;
`

export const Header_s = styled.header`
  align-items: center;
  background: ${Colors.white};
  display: flex;
  flex-direction: row;
  height: 50px;
  justify-content: space-between;
  line-height: 1;
  padding: 0 5px;
  position: fixed;
  width: 100%;
  z-index: 6;
`

export const HeaderIcon_s = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  a {
    cursor: pointer;
    opacity: 1;
  }
  a.disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  svg {
    height: 20px;
    width: auto;
    .r-svg {
      fill: ${Colors.blackPearl};
      height: 100%;
    }
  }

  .caret-right {
    height: 14px;
  }

  .new-notification-icon {
    &::after {
      border-radius: 100%;
      background-color: #1163BF;
      content: "";
      height: 8px;
      margin-left: 10px;
      position: absolute;
      width: 8px;
    }
  }
`

export const HeaderMiddle_s = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  > * {
    margin-left: 20px;
  }
`

export const HeaderRight_s = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 20px;
  > * {
    margin-left: 20px;
  }
`

export const HomeIcon_s = styled.div`
  cursor: pointer;
  svg { height: 18px; }
`

export const Logo_s = styled.a`
  height: 120%;
  img {
    height: 100%;
    width: auto;
  }
`

export const PropertySelection_s = styled.div`
  align-items: center;
  display: flex;
  > * { margin-right: 8px; }
  a { color: ${Colors.blackPearl}; }
  svg#homeIcon { height: 18px; }
  .p-dropdown {
    height: 25px;
    width: 245px;
    .p-dropdown-label {
      line-height: 24px !important;
    }
    .p-dropdown-item > div {
      align-items: center;
      display: flex;
      > * { margin-right: 4px; }
    }
    .p-input-overlay-visible {
      background-color: ${Colors.white};
    }
    .r-svg { fill: ${Colors.blackPearl}; }
  }
`

export const CalcStatus_s = styled.div<{status?:string}>`
  background: ${props => props.status ? Colors[`${`color${props.status}`}`]: Colors.blackPearl };
  border-radius: 100%;
  height: 14px;
  width: 14px;
`
export const NotifContainer_s = styled.div`
  max-height: 600px;
  overflow: auto;
  padding-right: 10px;
`

export const Notif_s = styled.div`
  display: flex;
  font-size: 14px;
  margin: 0 -10px;
  padding: 15px;
  &:not(:last-child){
    border-bottom: 1px solid ${Colors.towerGrey};
    //color: ${Colors.denim};
  }
  > div:first-child {
    width: 60%;
  }
  > div:nth-child(2) {
    color: ${Colors.chateauGrey};
    font-size: 12px;
    text-align: right;
    width: 30%;
  }
  > div:last-child {
    text-align: right;
    width: 10%;
    svg { height: 12px; }
  }
`
